// Root route ID
export const ROOT_ROUTE_ID = "root-route";
